import {differenceInDays} from 'date-fns';

type WorkingHoursByDay = {
	sunday: number;
	monday: number;
	tuesday: number;
	wednesday: number;
	thursday: number;
	friday: number;
	saturday: number;
};

type WorkingHoursForPersonForDayInput = {
	date: Date;
	personStartDate: Date;
	personEndDate: Date | null;
	workingHoursByDay: WorkingHoursByDay;
};

export function getWorkingHoursForPersonForDate({
	date,
	workingHoursByDay,
	personStartDate,
	personEndDate,
}: WorkingHoursForPersonForDayInput): number {
	const dayIsBeforePersonStartDate = differenceInDays(personStartDate, date) > 0;
	const personEndDateIsBeforeDay = personEndDate && differenceInDays(date, personEndDate) > 0;
	if (dayIsBeforePersonStartDate || personEndDateIsBeforeDay) return 0;
	const workingHoursArray = Object.values(workingHoursByDay); // Array will have weekdays Sunday - Saturday on index 0 - 6
	return workingHoursArray[date.getDay()]; // Date.getDay returns Sunday - Saturday : 0 - 6, use this to access appropriate index in workingHoursArray
}
